import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "plan-content mb-30" }
const _hoisted_2 = { class: "w-100 inputs-wrapper mb-20 d-flex flex-wrap gap-20" }
const _hoisted_3 = { class: "d-flex align-items-end gap-15 mt-20 ms-auto" }
const _hoisted_4 = {
  type: "submit",
  class: "btn btn-primary"
}

import { computed, reactive, ref, type Ref } from 'vue';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useModalStore } from '@/stores/modal';
import TextInput from '@components/form/TextInput.vue';

interface FormData {
    FullName: string;
    Email: string;
    PersonID: number;
}

interface ErrorFormData {
    FullName: string | null;
    Email: string | null;
}

const route = 'api/participant/pch-request';

export default /*#__PURE__*/_defineComponent({
  __name: 'RequestPchView',
  setup(__props) {

const authStore = useAuthStore();
const modalStore = useModalStore();

const userName = computed(() => authStore.userName);
const userEmail = computed(() => authStore.userEmail);
const participantId = computed<number>(() => authStore?.user?.participantId ?? 0);

const formData: FormData = reactive({
    FullName: userName.value ?? '',
    Email: userEmail.value ?? '',
    PersonID: participantId.value,
});

const loadingSubmit = ref(false);
const success = ref<string | null>(null);
const errors: Ref<Partial<ErrorFormData>> = ref({});

const handleCancel = () => modalStore.closeLastModal()

// Send Email
const handleSubmit = async () => {
    if (loadingSubmit.value) return;

    loadingSubmit.value = true;
    errors.value = {};

    try {
        const response = await axios.post(route, { ...formData });
        success.value = response.data?.success ?? null;

        if (success.value) {
            modalStore.openModal('success-modal', null, 'modal-success', null, {
                title: 'Pension Credits History Report',
                content: {
                    type: 'text',
                    value: success.value,
                },
            });
        }
    } catch (error: any) {
        if (error.response) {
            errors.value = error.response.data.errors ?? {};
        }
    } finally {
        loadingSubmit.value = false;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, "This will submit a request to the NBF Retirement services to run and email you a Pension Credits History Report. The report will be sent to your registered email address " + _toDisplayString(userEmail.value) + " within 24–48 hours. Click the Submit button to confirm.", 1),
    (userName.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(handleSubmit, ["prevent"]),
          onKeypress: _withKeys(handleSubmit, ["enter"]),
          class: "form update-address align-items-start mt-20",
          method: "post"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(TextInput, {
              type: "text",
              label: "Full Name",
              placeholder: "Enter Full Name",
              max: 50,
              readonly: true,
              modelValue: formData.FullName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.FullName) = $event)),
              error: errors.value?.FullName,
              isRequired: true
            }, null, 8, ["modelValue", "error"]),
            _createVNode(TextInput, {
              type: "email",
              label: "Email Address",
              placeholder: "Enter Email Address",
              max: 50,
              readonly: true,
              modelValue: formData.Email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.Email) = $event)),
              isRequired: true,
              error: errors.value?.Email
            }, null, 8, ["modelValue", "error"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: handleCancel
              }, "Cancel"),
              _createElementVNode("button", _hoisted_4, _toDisplayString(loadingSubmit.value ? 'Submitting...' : 'Submit'), 1)
            ])
          ])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}
}

})